import { useEffect, useMemo, useState } from "react";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";
import _ from "underscore";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { callautopopulate } from "../../../services/callautopop";

export const useQuickAction = () => {

    const { selectedEmployee } = useEmployeFilter();
    const { sidebarMenu } = useEmployeFilter();
    const [showGatePassPopup, setGatePassShowPopup] = useState(false);
    const [userCode, setUserCode] = useState(null);
    const Navigate = useNavigate();
    const [links, setLink] = useState([
        {
            name: "Bucket",
            color: "#6552f2",
            icon: <FontAwesomeIcon icon="fa-solid fa-cart-shopping" />,
        },
        {
            name: "HelpDesk",
            color: "#7a7b7a",
            icon: <FontAwesomeIcon icon="fa-solid fa-headphones" />,
        },
        {
            name: "Gate Pass",
            color: "#46b35c",
            icon: <FontAwesomeIcon icon="fa-solid fa-address-card" />
        }
    ]);

    useEffect(() => {
        callautopopulate("user_info").then((res) => {
            setUserCode(res?.user_info[0]?.user_code)
        })
        selectedEmployee?.user_code && QuickActionsCount(selectedEmployee?.user_code)
    }, [selectedEmployee?.user_code])


    // Api calling for get count for quick links
    const QuickActionsCount = async (usecode) => {
        let payload = {
            requested_user_code: usecode
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETACTIONREQUESTSUMMARY'), payload)
            if (res.body.data?.myaction_request_summary) {
                const data = res.body.data?.myaction_request_summary?.[0]
                const linksWithCount = links.map(link => {
                    let count = 0;
                    let click = () => { };
                    let disable = userCode !== selectedEmployee?.user_code
                    if (link.name === "Bucket") {
                        count = data.bucket_data;
                        click = (count > 0 && userCode === selectedEmployee?.user_code)
                            ? () => { Navigate("/estimating") }
                            : () => { };

                    } else if (link.name === "HelpDesk") {
                        count = data.helpdesk_request_data;
                        const link = _.filter(sidebarMenu, { key: "HelpDesk" })
                        click = userCode === selectedEmployee?.user_code
                            ? () => { link?.length > 0 && Navigate(link?.[0]?.to, { state: { key: "back" } }) }
                            : () => { }
                    } else if (link.name === "Gate Pass") {
                        count = data.gatepass_request;
                        click = () => userCode === selectedEmployee?.user_code && setGatePassShowPopup(true);
                    }

                    return { ...link, count, click ,disable};
                });
                setLink(linksWithCount)
            } else {
                console.error(res.body.message);
            }
        } catch (error) {
            console.error(error, "error");
        }
    }

    return useMemo(() => ({
        showGatePassPopup, links, setGatePassShowPopup
    }), [ showGatePassPopup, links, setGatePassShowPopup])
}